<map-marker [position]="marker.position"
            [label]="marker.label"
            [title]="marker.title"
            [options]="marker.options"
            (mapClick)="markerClick.emit()">
</map-marker>
